/*
 * Copyright (c) Nexign, JSC, 2021-2023.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @version 1.23.0
 * @since 1.14.0
 */

import { useFormikContext } from 'formik';
import type { FormikProps } from 'formik/dist/types';

import type { IFormFieldProps } from '../../form/components/FormField';
import FormFieldCheckbox from '../../form/components/FormFieldCheckbox';
import type { IFormAddressConfiguration } from '../types/formAddressTypes';
import { EFormAddressField } from '../types/formAddressTypes';

interface IFormAddressCheckbox extends IFormFieldProps {
  isDisabled: (
    field: EFormAddressField,
    {
      getFieldProps,
    }: Pick<FormikProps<IFormAddressConfiguration>, 'getFieldProps'>,
  ) => boolean;
  onChange: (
    field: EFormAddressField,
    checked: boolean,
    {
      setFieldValue,
      setFieldTouched,
      values,
    }: Pick<
      FormikProps<IFormAddressConfiguration>,
      'setFieldValue' | 'setFieldTouched' | 'values'
    >,
  ) => void;
}

const FormAddressCheckbox = ({
  isDisabled,
  disabled,
  name,
  onChange,
  ...props
}: IFormAddressCheckbox) => {
  const { setFieldValue, setFieldTouched, getFieldProps, values } =
    useFormikContext<IFormAddressConfiguration>();

  const handleOnChange = (checked: boolean) => {
    onChange(name as EFormAddressField, checked, {
      setFieldValue,
      setFieldTouched,
      values,
    });
  };

  return (
    <FormFieldCheckbox
      {...props}
      disabled={
        disabled || isDisabled(name as EFormAddressField, { getFieldProps })
      }
      name={name}
      onChange={handleOnChange}
    />
  );
};

export default FormAddressCheckbox;
